import { Stack } from '@mui/material'
import React from 'react'
import { FeudStack } from './stacks'
import { HeaderTertiary } from '../../typography'
import { SPACING } from '../../typography'

export function FeudItem(props) {
  const { children, name } = props
  return (
    <>
      <Stack spacing={SPACING} direction='column'>
        {name && <HeaderTertiary>{name}</HeaderTertiary>}
        <FeudStack {...props} />
      </Stack>
      {children}
    </>
  )
}
